import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { PillButton } from 'components'
import { makeStyles, Typography, Box, IconButton, Theme } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { ReactComponent as BellIcon } from '../../assets/BellIcon.svg'

interface INoticeProps {
  message: string
  onClose: () => void
  streamUrl?: string
  onClick?: () => void
  buttonText?: string
  hideBell?: boolean
}

export const Notice: FC<INoticeProps> = ({ message, streamUrl, onClick, onClose, buttonText, hideBell }) => {
  const history = useHistory()
  const classes = useStyles()

  return (
    <div className={classes.modal}>
      <div className={classes.modalBody}>
        <Box p={4}>
          <Box mb={4} mt={2}>
            <Typography style={{ color: '#000' }} variant='h4'>
              {hideBell ? null : (
                <div className={classes.notificationIconWrapper}>
                  <BellIcon className={classes.notificationIcon} />
                </div>
              )}

              {message}
            </Typography>
          </Box>
          <Box>
            <PillButton
              type='button'
              variant='outlined'
              solid
              onClick={() => {
                if (streamUrl) {
                  return history.push(streamUrl)
                }
                onClick?.()
              }}
            >
              {buttonText || 'Join the live stream'}
            </PillButton>
          </Box>
        </Box>
        <IconButton className={classes.closeButtonModal} onClick={onClose}>
          <Close />
        </IconButton>
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 9999,
    height: '100vh',
    width: '100vw',
    top: 0,
    left: 0
  },
  modalBody: {
    backgroundColor: '#fff',
    width: 460,
    position: 'relative'
  },
  notificationIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    width: 45,
    marginBottom: '1.5rem'
  },
  notificationIcon: {
    color: '#000'
  },
  closeButtonModal: {
    position: 'absolute',
    right: 0,
    top: 0
  }
}))
